import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Lock, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Friendly "sign in to unlock" dialog for guests who tap a gated feature
 * (Strong's, dictionaries, commentaries, or any interaction).
 */
const LoginPromptDialog = ({ open, feature, onClose }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const es = language === 'es';

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="login-prompt-dialog">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
            <Lock className="h-6 w-6 text-amber-600 dark:text-amber-400" />
          </div>
          <DialogTitle className="text-center text-xl">
            {es ? 'Inicia sesión para desbloquear' : 'Sign in to unlock'}
          </DialogTitle>
          <DialogDescription className="text-center">
            {feature
              ? (es ? `${feature} requiere una cuenta gratuita.` : `${feature} requires a free account.`)
              : (es ? 'Esta función requiere una cuenta gratuita.' : 'This feature requires a free account.')}
            {' '}
            {es ? 'La lectura de la Biblia siempre es gratis.' : 'Bible reading is always free.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-col gap-2">
          <Button
            onClick={() => navigate('/login')}
            className="w-full bg-amber-600 hover:bg-amber-700 text-white"
            data-testid="login-prompt-signin"
          >
            <Sparkles className="mr-2 h-4 w-4" />
            {es ? 'Iniciar sesión / Registrarse' : 'Sign in / Sign up — free'}
          </Button>
          <Button variant="ghost" onClick={onClose} className="w-full" data-testid="login-prompt-dismiss">
            {es ? 'Seguir leyendo' : 'Keep reading'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LoginPromptDialog;
